import styled from 'styled-components';
import { Y_SCROLL_BAR_WIDTH } from '../../global-styles';

const Form = styled.div`
  padding: 16px ${24 - Y_SCROLL_BAR_WIDTH}px 16px 24px;
  overflow-y: scroll;
`;

export default Form;
